import React from "react";

const BlockedIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 0C4.1 0 0.5 3.6 0.5 8C0.5 12.4 4.1 16 8.5 16C12.9 16 16.5 12.4 16.5 8C16.5 3.6 12.9 0 8.5 0ZM8.5 1.77778C9.87778 1.77778 11.1667 2.26667 12.2333 3.02222L3.52222 11.7333C2.76667 10.6667 2.27778 9.37778 2.27778 8C2.27778 4.57778 5.07778 1.77778 8.5 1.77778ZM8.5 14.2222C7.12222 14.2222 5.83333 13.7333 4.76667 12.9778L13.4778 4.26667C14.2333 5.33333 14.7222 6.62222 14.7222 8C14.7222 11.4222 11.9222 14.2222 8.5 14.2222Z"
        fill="#D50000"
      />
    </svg>
  );
};

export default BlockedIcon;
